// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1_g1h","overlay":"style_overlay__2s5Bs","overlay_test":"style_overlay_test__12ZL3"};